export type Icons = {
    [key: string]: string;
}

export const icons: Icons = {
    refreshIco: '/icons/reload.svg',
    starFilledIco: '/icons/star-filled.png',
    starEmptyIco: '/icons/star-empty.png',
    starHalfIco: '/icons/star-half.png',
    exportIco: '/icons/export.svg',
    printIco: '/icons/print.svg',
    printWhiteIco: '/icons/print-white.svg',
    actionsIco: '/icons/actions.png',
    locationIco: '/icons/location.svg',
    homeIco: '/icons/home.svg',
    userIco: '/icons/user.svg',
    passwordIco: '/icons/password.svg',
    createBuildingsIco: '/icons/create.svg',
    infoIco: '/icons/info.svg',
    homeDarkIco: '/icons/home-dark.png',
    homeBlueIco: '/icons/home-blue.png',
    statsSmIco: '/icons/stats-sm.svg',
}